import React from "react";

import { AVAILABLE_LANGS } from "@typings/globals";

import { BentoBox } from "@components/DataDisplay/BentoBox";

import { mediaQueriesV2 } from "@ui/themes/default";

import { useTranslate } from "@hooks/useTranslate";

import {
  desktopImage,
  largeDesktopImage,
  mobileImage,
  tabletImage,
} from "./EasyManageable.helpers";

const base64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABeBJREFUWEeFVw1rXUUQnb2f7yWoKCiI0KY1ptEofmCx2iiCWAhYUNEiVfH//4D23Y+9d+Wcmdm9LxVMsuxLcvPmzJkzZybhn68/TCmJpHWVlWeRddE7+c0HkvhHCEEkiAhuCZKCCH67isiSkizrKtHPgteLRN4rf7ckvH8SfIa/v7pMePPEH645OEAkgFlXBidKxtTgetsBCAJICiClDGBePPiiABYFgPfDW4bnX54DSAGwriVzvDZweIYJS2DwUOntIJA9QNwGEJdF5g0LrzDw7LMzYyBtyoDsERw33jYZ4xY8VAqgqjKIFAJLsB4xYMEJwhiwMuA5JBd+vXpPyfW65MCavdce2VY4CFpVvP01WAAAL0M0HTBzBKcGFMyyLMcaePrgHSuB6oCUW91LcJEqICAA1FLVldR1zdehBguVAghgAGUoIkTmPBEMKBCUIYvw5v23lADL1oNToVZ3Zl9VUuPUtdRNowDsgBGpqqNOYBdsgs9L1DIYAIBgCZ6cvQGe9StTrt+rxpR6Bq5raXAAwE8NFmpQxD8AAyiBt94UNfCM215TiA7gx7uvHTHAXgMyazkNrpkjsJ5W2raAABNkwAB4CUD7hMxjlGmOfB1RCmOBDCgA7Ulnwj0G2ZP2CsEVQNsiuJ6mbckEAKAM3glxVQYIIEYZ46wA4kwwGcCKEtx7nSLULtbLAWzr3m6DdwDQEUDTAkBzBAD0gnYEJ4B55pl4HABMLkm4OX9TI2+t9oh+rTsoR9Zd20nbddJ1nTRdy3JUDRioqQG34skAMPgEABNvZwGOuKZVwk+Xb2cRqs/ph/Y8SmDUN410XcvAbdfb7QA2DJgNT3Eh9eM0yWCHAGaUYeZsgM2Hnz9+t0wZ9/sMAOKrpKk9+1a6Htk7gE5q6MA6wa0YLQjqB2Q+TXKYRhlGBYLvqYO4KAO/fX7nuATbDrDed/F1KAHo7wsA6IAaqOEDKAHqDwAzAQzjKAc7AAEAYAFCJAN/PLy/acMixkq0BHA7dEDbILgBAAO9akE14CUQQQdQgLMCQPCXw5BBjOOYAUCs4fmji8yAjtxiQqqDrQhVfM4CAZABFSH+GiYEiiE+UP4S2Q+DghhQCgWAZ8jAX4+xkOjQKXdpRbdfMNBmBlQHGYAxwIVkTTQcCI4ALLgCUCamaQvg+uoIgI5hWz4gxgoiLCaUGfgPAIWBRYZ5ovAcwIvDwRgYCC4z8OfjK+TOue+TUKeisuBzgEJ0FjYihCEVDYTCwIz6T8z6xQElOBDMMIy5E1SE31zRh9ESAIEf5nEMXdOObQh5F5gIUQaYUd202QlhRLBgaOCAFvw/AL8/ur2U6i5YNiEdxcpAoy5IBkonAACEmELFjQhdMMIHUIJxkJdkQA9E6F6AvTP88vCSGshbsfWnawEjGcuIT0LvgB4gegixt05oOBGxmKoPwIim3IYAgS5QEaoZsQ2ffnGxAbBwZdK1XLdh2nIV6IboeQBA8H4HADuCaNqOU1HMjNQJUQYA0DLkNpzAwEaEN5+eZwAa3ECYFihE24Q4jLreAOyk3ykAsABL1jLoQKIOogmRXqDZv+IDTz65n1x8XBgJIpIFNyaUAH4Pxfc9jgbf7fe8WYauIwCWIYnMeR5oO7odo/442Yp/+Ohe8n9KCCAChANAGQoDGMWw4J0F3+320u/3LAXECRZUB2jHVTCS3ZCYvQXnLHANfH95dgtANBa8E8wLMI7b1ujfy36/l93JSWHBtID9UIcSHBEzIWZT8ux9GFGE3z24Sw147ZG9slBaUd1Q9wHQj8z3JzgAoCDafkdPwGRMLEPpBp8LXEwwDTmOI58J314AgP5PiKCkxkuATjA3pA+wA3bMHsH9AERHLagrug4wGbcrGRmwtYxaAwPXF3c2ItRFYQE6f8DnAXfCUv8TAjgV3CiFAtBuUB2U0VzWMmxE2Ad0L+ROeP3BHZaAuzqyNxFqCZwBNSJ4gAswAzg9ZRn6vQKoWrVlCNFHM1ngXqhndgBplX8BOwl3xvR3pxsAAAAASUVORK5CYII=";

export const EasyManageable: React.FC<
  Pick<React.ComponentPropsWithoutRef<"div">, "className"> & {
    language: AVAILABLE_LANGS;
  }
> = ({ className, language }) => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <BentoBox
      heading={translate("features_bento_manageable_heading")}
      description={translate("features_bento_manageable_description")}
      variant="medium"
      className={className}
    >
      <BentoBox.Image
        width={1121}
        height={1084}
        src={mobileImage(language)}
        alt={translate("features_bento_manageable_alt")}
        loading="lazy"
        base64={base64}
        sources={[
          {
            srcSet: mobileImage(language),
            media: mediaQueriesV2.largeMobile,
          },
          {
            srcSet: tabletImage(language),
            media: mediaQueriesV2.smallTablet,
          },
          {
            srcSet: tabletImage(language),
            media: mediaQueriesV2.tablet,
          },
          {
            srcSet: desktopImage(language),
            media: mediaQueriesV2.smallDesktop,
          },
          {
            srcSet: desktopImage(language),
            media: mediaQueriesV2.desktop,
          },
          {
            srcSet: largeDesktopImage(language),
            media: mediaQueriesV2.largeDesktop,
          },
        ]}
      />
    </BentoBox>
  );
};
